"use client";

import { ArrowRight } from "lucide-react";
import { useRouter } from "next/navigation";
import { RainbowButton } from "@/components/magicui/rainbow-button";
import Link from "next/link";

// The audit CTA leads to the Revenue Code Diagnostic — the lead magnet.
export function SolutionsCta() {
  const router = useRouter();

  return (
    <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
      <RainbowButton className="group" onClick={() => router.push("/diagnostic")}>
        Get Your Free Audit
        <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
      </RainbowButton>
      <Link
        href="/contact"
        className="text-sm font-medium text-neutral-400 hover:text-white transition-colors cursor-pointer"
      >
        Or talk to our team →
      </Link>
    </div>
  );
}
